<template>
  <div class="config-container">
    <div v-if="documentData">
      <div class="container-top">
        <b-row class="">
          <b-col class="pl-0" cols="9">
            <span v-if="!editDocumentName" class="document-name" @click="editDocName()">
              {{ documentData.docName }}
              <span class="fa fa-pencil pl-2 fs-16" aria-hidden="true"></span>
            </span>
            <div class="pr-0 edit-document-name" v-else>
              <b-input-group>
                <b-input-group-text slot="append" class="p-5" v-bind:class="{ 'is-danger': documentNameError }">
                  <i class="fa fa-times mr-4 fs-16" @click="cancelDocumentNameEdit()" aria-hidden="true"></i>
                  <i class="fa fa-check-square primaryColor fs-24" @click="validateDocName()" aria-hidden="true"></i>
                </b-input-group-text>
                <b-form-input v-model="documentData.docName" onClick="this.select();" class="docNameInput" v-bind:class="{ 'is-danger': documentNameError }"> </b-form-input>
              </b-input-group>
            </div>
          </b-col>
          <b-col cols="3" class="p-0 text-right">
            <div class="cancel-btn" :class="{ disabled: processing }" v-on="!processing ? { click: () => cancelConfiguration() } : {}"><img src="static/img/add.svg" alt="" class="mb-2" /> Cancel</div>
            <b-button :disabled="processing" variant="primary" size="md" @click="saveDocumentConfiguration">Save</b-button>
          </b-col>
        </b-row>
      </div>
      <div class="row pt-48">
        <div class="col col-md-8 col-lg-9 left-outer-container" @scroll="scrollImage" :class="{ disabledScreen: saveBtnClickEvent }">
          <div class="document-container" style="display: table;margin: auto;">
            <drop
              ref="dropZone"
              @drop="dropHandler"
              class="drop-zone"
              :style="{
                width: `${dropContainerWidth}px`,
                height: `${dropContainerHeight}px`
              }"
            >
              <div v-for="(pageImage, iIndex) in pdfPagesImages" :key="`pdf-page-${pageImage.pageNumber + 1}`" class="pdf-page" :id="`pdf-page-${iIndex}`">
                <img :data-page="pageImage.pageNumber + 1" :src="`data:image/png;base64,${pageImage.image}`" :style="`margin: 0 auto; max-width: 100%;`" width="100%" height="auto" class="page-img" draggable="false" @dragstart="false" />
                <div class="page-separator" :class="{ last: iIndex == pdfPagesImages.length - 1 }" :style="`height: ${pdfPageSeparatorHeight}px;`"></div>
              </div>
              <vue-draggable-resizable
                class-name="signing-tab"
                class-name-active="active-sign-tab"
                v-for="(item, sIndex) in signingTabs.filter(signingTab => signingTab.active)"
                :key="`tab-${item.role}-${item.fieldType}-${sIndex}-${item.xCoordinate}-${item.yCoordinate}-${item.pageNumber}`"
                :resizable="false"
                :parent="true"
                :w="signTabWidth"
                :h="signTabHeight"
                :x="item.xCoordinate"
                :y="item.yCoordinate"
                @dragstop="(left, top) => dragStop(item, sIndex, left, top)"
                :active="item.edit ? true : false"
                :prevent-deactivation="item.edit ? true : false"
                :draggable="isDragabble ? true : item.edit ? true : false"
                :id="`tab-${item.role}-${item.fieldType}-${sIndex}-${item.xCoordinate}-${item.yCoordinate}-${item.pageNumber}`"
              >
                <span v-if="item.role === 'caregiver' || item.role === 'observer' || item.role === 'witness'" class="order-number">{{ item.roleOrder }}</span>
                <span :style="{ 'background-color': roleColorCode[item.role] }" :class="item.fieldType" class="color-indicator"></span>
              </vue-draggable-resizable>
            </drop>
          </div>
        </div>
        <div class="col col-md-4 col-lg-3 right-outer-container" :class="{ disabledScreen: saveBtnClickEvent }">
          <div class="right-panel">
            <div class="roles-container">
              <ul>
                <drag :tag="'li'" :draggable="isDragabble" :effect-allowed="['move']" drop-effect="move" :transfer-data="roleObj" v-for="(roleObj, index) in dragabbleRoles" :key="`role-${index}`" :class="{ 'no-select': !isDragabble }" @dragstart="setCurrentRole(roleObj)">
                  <img src="static/img/drag-bullets.svg" alt="" class="drag-bullet" />
                  <p class="role-text">{{ roleObj.role }}</p>
                  <span :style="{ 'background-color': roleObj.color }" class="color-indicator" :class="{ 'extra-margin': roleObj.roleKey === 'caregiver' }"></span>
                  <div slot="image" class="drag-role">
                    <span :style="{ 'background-color': roleObj.color }" class="role-color-indicator"></span>
                  </div>
                </drag>
              </ul>
              <div class="disclaimer-btn-container">
                <button class="btn btn-block btn-outline-primary" :disabled="processing" @click="showDisclaimerPopup()">
                  Add a disclaimer
                </button>
              </div>
            </div>
            <div class="configured-fields-container">
              <configuredFields :signingTabs="signingTabs" :roleColorCode="roleColorCode" @editSignHere="editSignField" @updateSignFieldConfig="updateSignFieldConfig" @deleteSignFieldConfig="deleteSignFieldConfig" />
            </div>
            <div v-if="disclaimersObj && disclaimersObj.length" class="disclaimer-container">
              <ul>
                <li v-for="(disclaimerObj, index) in disclaimersObj.filter(item => item.active)" :key="`dis-key-${index}`">
                  Disclaimer {{ index + 1 }}
                  <span @click="showDisclaimerPopup()" class="fa fa-pencil" aria-hidden="true"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Disclaimer add/edit modal -->
      <addEditDisclaimerModal ref="disclaimerModal" :disclaimers="disclaimersObj" :totalPdfImages="pdfPagesImages.length" :signingTabs="signingTabs" @saveDisclaimers="addUpdateDisclaimers" @deleteExistingDiscliamer="deleteExistingDiscliamer" @resetDeletedDisclaimer="resetDeletedDisclaimer" @deleteDisclaimerPage="deleteDisclaimerPage" />
    </div>
    <div v-else class="snippet" data-title=".dot-stretching">
      <div class="stage">
        <div class="dot-stretching"></div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import VueDraggableResizable from "vue-draggable-resizable";
import addEditDisclaimerModal from "@/components/configure-document/add-edit-disclaimer-modal";
import configuredFields from "@/components/configure-document/configured-fields";
import { SYSTEM_ADMIN, STUDY_ADMIN, STUDY_MANAGER } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import _ from "lodash";
import { TEST_PORTAL_SUFFIX } from "@/constants/config";

export default {
  name: "ConfigureDocument",
  data: function() {
    return {
      studyId: this.$route.params.studyId,
      siteId: this.$route.query.siteId,
      documentId: this.$route.params.documentId,
      returnTo: this.$route.query.returnTo,
      dropContainerWidth: 733,
      dropContainerHeight: null,
      pdfPageSeparatorHeight: 13,
      signTabWidth: 43,
      signTabHeight: 43,
      pdfPageHeight: 0,
      editDocumentName: false,
      documentNameError: false,
      originalDocumentName: null,
      documentData: null,
      currentRoleDragged: "",
      dragabbleRoles: [
        {
          role: "Participant",
          roleKey: "participant",
          color: "#d9f5f7"
        },
        {
          role: "Parent/ Legal Guardian/ Caregiver",
          roleKey: "caregiver",
          color: "#e3f9d6"
        },
        {
          role: "Research Site",
          roleKey: "researchsite",
          color: "#f9f5d6"
        },
        {
          role: "Observer",
          roleKey: "observer",
          color: "#f9e5d6"
        },
        {
          role: "Witness",
          roleKey: "witness",
          color: "#ecd6f9"
        }
      ],
      disclaimersObj: [],
      existingDeletedDisclaimersTemp: [],
      existingDeletedDisclaimers: [],
      isDragabble: true,
      draggingId: null, //the element or div which is currently being dragged
      signingTabs: [],
      pdfPagesImages: [],
      pdfPagesStartEndArray: [], //Contains the pages start Y and end Y
      processing: false,
      roleColorCode: [],
      fieldToDelConfOnDisclaimerPage: [],
      currentCount: 0,
      totalMainPage: 1,
      saveBtnClickEvent: false,
      pdfPagesLastIndexValue: 0,
      totalCheckImages: 0
    };
  },
  components: {
    addEditDisclaimerModal,
    configuredFields,
    VueDraggableResizable
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    isTestPortal() {
      return (this.$route.name || this.$route.currentRoute.name || "").includes(TEST_PORTAL_SUFFIX);
    }
  },
  methods: {
    setCurrentRole(roleObj) {
      this.currentRoleDragged = roleObj.roleKey;
    },
    editDocName() {
      this.editDocumentName = !this.editDocumentName;
      this.documentNameError = false;
    },
    cancelDocumentNameEdit() {
      this.editDocumentName = !this.editDocumentName;
      this.documentData.docName = this.originalDocumentName;
    },
    validateDocName() {
      if (this.documentData.docName.trim().length === 0) {
        this.documentNameError = true;
        this.$toastr.error("Document name is required.");
        return true;
      } else {
        this.documentNameError = false;
        this.editDocumentName = false;
        this.originalDocumentName = this.documentData.docName;
        return false;
      }
    },
    dropHandler(data, event) {
      if (!data) {
        return;
      }

      let xPosition = event.layerX;
      const yPosition = event.layerY;
      //get the image details on which role box is dropped
      //Below calculations will prevent role box from being dropped out of drop container.
      const rect = event.target.getBoundingClientRect();
      const widthOffsetDiff = rect.width - event.offsetX;

      if (widthOffsetDiff < this.signTabWidth) {
        xPosition = xPosition - this.signTabWidth;
      }

      const elements = document.elementsFromPoint(event.clientX, event.clientY);
      const pageImg = elements.find(
        el => el.classList.contains("page-img")
      );

      let pageNumber, height;
      if (pageImg) {
        pageNumber = pageImg.dataset.page;
        height = pageImg.offsetHeight;
      }

      const newSignHereTab = {
        active: true,
        role: data.roleKey,
        roleOrder: 1,
        fieldType: "signature",
        fieldName: "Signature",
        fieldLabel: "", //specifically need for checkbox type field
        fieldInstruction: "",
        sequence: 1,
        required: true,
        xCoordinate: xPosition,
        yCoordinate: yPosition,
        edit: true,
        colorCode: data.color,
        pageNumber: Number(pageNumber), // page number of PDF,
        width: this.dropContainerWidth,
        height: height
      };

      // this.setPageNumberNyCoordinate(newSignHereTab, yPosition);

      //now find out the field count index
      const filterFieldType = _.filter(this.signingTabs, {
        fieldType: newSignHereTab.fieldType,
        role: newSignHereTab.role,
        active: true
      });
      newSignHereTab.sequence = filterFieldType.length + 1;

      //Now push this data to the signingTabs which can be dragged further on the documents
      this.signingTabs.push(newSignHereTab);
      //Make the ROLEs list undraggable
      this.isDragabble = false;
    },
    dragStop(item, itemIndex, left, top) {
      this.draggingId = null;
      item.xCoordinate = left;
      this.setPageNumberNyCoordinate(item, top);
    },
    showDisclaimerPopup() {
      if (!this.isDragabble) {
        //It means user is in the middle of editing any field do not allow add/edit
        this.$toastr.error("Please save the changes.");
        return;
      }
      this.$refs.disclaimerModal.show();
    },
    addUpdateDisclaimers(disclaimerList) {
      const self = this;
      self.processing = true;
      const totalPDFPages = self.pdfPagesImages.length;
      self.fieldToDelConfOnDisclaimerPage = _.sortBy(self.fieldToDelConfOnDisclaimerPage);
      if (self.fieldToDelConfOnDisclaimerPage.length > 0) {
        for (const page of self.fieldToDelConfOnDisclaimerPage) {
          const filterSignTab = _.filter(self.signingTabs, {
            pageNumber: page
          });
          _.map(filterSignTab, async signtab => {
            const delfieldConfig = _.cloneDeep(signtab);
            signtab.active = false;

            //Since the field is deleted now, filter the data by deleted field type to adjust the remaining field of same type sequence
            await self.adjustFieldSequence(delfieldConfig);
          }); //end map
        } //end for of

        for (const page of self.fieldToDelConfOnDisclaimerPage) {
          //Need to adjust the y coordinate & pagenumber on all the pages after the deleted one.
          for (let z = page + 1; z <= totalPDFPages; z++) {
            const SignTabOfPage = _.filter(self.signingTabs, {
              pageNumber: z,
              active: true
            });
            _.map(SignTabOfPage, async stab => {
              stab.yCoordinate = stab.yCoordinate - self.pdfPageHeight - self.pdfPageSeparatorHeight;
              stab.pageNumber = stab.pageNumber - 1;
            });
          }
        }
      }

      nprogress.start();
      self.disclaimersObj = disclaimerList;
      self.disclaimersObj = self.disclaimersObj.concat(self.existingDeletedDisclaimersTemp);
      const pathParams = {
        studyId: this.studyId,
        siteId: this.siteId,
        documentId: this.documentId
      };
      self.$api.getDisclaimerImages(pathParams, self.disclaimersObj).then(
        () => {
          self.existingDeletedDisclaimers = [...self.existingDeletedDisclaimers, ...self.existingDeletedDisclaimersTemp];
          self.existingDeletedDisclaimersTemp = [];
          self.fieldToDelConfOnDisclaimerPage = [];
          nprogress.done();
          self.processing = false;
          if (self.currentCount == self.totalMainPage) {
            const newPathParams = {
              studyId: self.studyId,
              siteId: self.siteId,
              documentId: self.documentId,
              page: parseInt(self.totalMainPage - 1)
            };
            let previousPdfPages = [];
            for (let i = 0; i < self.pdfPagesLastIndexValue; i++) {
              previousPdfPages.push(self.pdfPagesImages[i]);
            }
            self.$api.getSinglePagewiseConfiguredDocumentDetails(newPathParams).then(
              response => {
                self.$store.commit("SHOW_LOADER", false);
                self.documentData = response.body;
                self.originalDocumentName = self.documentData.docName;
                self.disclaimersObj = self.documentData.disclaimerList;
                previousPdfPages = previousPdfPages.concat(response.body.documentImages);
                self.pdfPagesImages = previousPdfPages;
                self.totalCheckImages = self.pdfPagesImages.length;
                self.setDropContainerWithPDFImages();
              },
              error => {
                self.$store.commit("SHOW_LOADER", false);
                nprogress.done();
                self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting configured document details");
              }
            );
          }
        },
        error => {
          self.fieldToDelConfOnDisclaimerPage = [];
          nprogress.done();
          self.processing = false;
          self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving configured document details.");
        }
      );
    },
    deleteExistingDiscliamer(disclaimer) {
      this.existingDeletedDisclaimersTemp.push(disclaimer);
    },
    resetDeletedDisclaimer() {
      this.existingDeletedDisclaimersTemp = [];
      this.fieldToDelConfOnDisclaimerPage = [];
    },
    deleteDisclaimerPage(pageNo) {
      this.fieldToDelConfOnDisclaimerPage.push(pageNo);
    },
    editSignField(editIndex) {
      //Event handler to edit the already configured signing fields
      _.map(this.signingTabs, signtab => {
        if (signtab.edit == undefined) {
          //this means the key does not exist because its a get response array which does not have an edit key
          this.$set(signtab, "edit", false);
        } else {
          signtab.edit = false;
        }
      });
      this.signingTabs[editIndex].edit = true;
      this.isDragabble = false;
      const editTab = this.signingTabs[editIndex];
      const signTabId = `tab-${editTab.role}-${editTab.fieldType}-${editIndex}-${editTab.xCoordinate}-${editTab.yCoordinate}-${editTab.pageNumber}`;
      this.scrollToId(signTabId);
    },
    updateSignFieldConfig(updateIndex, updatedData, isCancelled = false) {
      this.signingTabs[updateIndex].edit = false;
      if (isCancelled) {
        this.isDragabble = true;
        return;
      }

      this.signingTabs[updateIndex].roleOrder = updatedData.roleOrder;
      //Event handler to update the already configured sign field
      this.signingTabs[updateIndex].required = updatedData.required;
      this.signingTabs[updateIndex].fieldLabel = updatedData.fieldLabel;
      this.signingTabs[updateIndex].fieldInstruction = updatedData.fieldInstruction;

      //Update field type and name only when it is changed.
      if (this.signingTabs[updateIndex].fieldType != updatedData.fieldType) {
        const oldfieldConfig = _.cloneDeep(this.signingTabs[updateIndex]);
        this.signingTabs[updateIndex].fieldType = updatedData.fieldType;
        this.signingTabs[updateIndex].fieldName = updatedData.fieldName;

        if (updatedData.fieldType != "checkbox" && updatedData.fieldType != "text") {
          this.signingTabs[updateIndex].fieldLabel = "";
          this.signingTabs[updateIndex].fieldInstruction = "";
        }

        //filter the data by this new fieldType to get the label count index
        const filterSignTab = _.filter(this.signingTabs, {
          fieldType: updatedData.fieldType,
          role: updatedData.role,
          active: true
        });
        this.signingTabs[updateIndex].sequence = filterSignTab.length;

        //Now filter the data by old field type to adjust their count index
        const oldSignFieldTab = _.filter(this.signingTabs, {
          fieldType: oldfieldConfig.fieldType,
          role: updatedData.role,
          active: true
        });
        if (oldSignFieldTab.length > 0) {
          _.map(oldSignFieldTab, (signtab, index) => {
            signtab.sequence = index + 1;
          });
        }
      }

      //Make the Roles draggable again
      this.isDragabble = true;
    },
    deleteSignFieldConfig(deleteIndex) {
      const delfieldConfig = _.cloneDeep(this.signingTabs[deleteIndex]);
      //If it is an existing field then set the active flag to false or else delete this field
      if (this.signingTabs[deleteIndex].id) {
        this.signingTabs[deleteIndex].active = false;
        this.signingTabs[deleteIndex].edit = false;
      } else {
        this.signingTabs.splice(deleteIndex, 1);
      }

      //Since the field is deleted now, filter the data by deleted field type to adjust the remaining field of same type sequence
      this.adjustFieldSequence(delfieldConfig);
      this.isDragabble = true;
    },
    async adjustFieldSequence(signTab) {
      //Since the field is deleted now, filter the data by deleted field type to adjust the remaining field of same type sequence
      const remSignFieldTab = _.filter(this.signingTabs, {
        fieldType: signTab.fieldType,
        role: signTab.role,
        active: true
      });
      if (remSignFieldTab.length > 0) {
        _.map(remSignFieldTab, (signtab, index) => {
          signtab.sequence = index + 1;
        });
      }
    },
    async getConfiguredDocumentDetails() {
      const pathParams = {
        studyId: this.studyId,
        siteId: this.siteId,
        documentId: this.documentId,
        page: this.currentCount
      };
      const getFirstResponse = await this.$api.getSinglePagewiseConfiguredDocumentDetails(pathParams).catch(error => {
        if (error.status === 403) {
          this.$toastr.error("Access restricted");
          this.$router.push({
            name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}study-participants-list`,
            params: { studyId: this.studyId }
          });
        }
      });
      const getTotalMainPageCount = parseInt(getFirstResponse.body.totalMainPage);
      pathParams.page = getTotalMainPageCount - 1;
      const getLastResponse = await this.$api.getSinglePagewiseConfiguredDocumentDetails(pathParams);
      const getTotalDisclaimerCount = parseInt(getLastResponse.body.totalDisclaimers);
      this.totalCheckImages = getTotalMainPageCount + getTotalDisclaimerCount;
      this.callSinglePdfImage(this.currentCount);
    },
    cancelConfiguration() {
      this.$swal({
        title: "Are you sure you want to close this screen? Any changes made will not be saved.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.processing = true;
          this.redirectToDocumentListingPage();
        }
      });
    },
    saveDocumentConfiguration() {
      if (this.validateDocName()) {
        //true means there is some error in document name;
        return;
      }
      //Lets first remove the keys that are not needed for backend purpose from signingTabs
      _.map(this.signingTabs, signtab => {
        delete signtab.edit;
        delete signtab.colorCode;
      });
      //Delete documentImages, totalImages
      delete this.documentData.documentImages;
      delete this.documentData.totalImages;

      this.documentData.platformDocumentConfigurations = this.signingTabs;

      //Merge existing delete discliamers to the main obj so that backend can delete them too
      this.documentData.disclaimerList = [...this.disclaimersObj, ...this.existingDeletedDisclaimers];

      const pathParams = {
        studyId: this.studyId,
        siteId: this.siteId,
        documentId: this.documentId
      };
      this.currentCount = this.totalMainPage;
      this.saveBtnClickEvent = true;
      nprogress.start();
      this.processing = true;
      this.$api.saveConfigureDocumentDetails(pathParams, this.documentData).then(
        () => {
          nprogress.done();
          this.$toastr.success("The document configuration is being saved. This may take a few moments.");
          this.redirectToDocumentListingPage();
        },
        error => {
          nprogress.done();
          this.processing = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving configured document details.");
        }
      );
    },
    setDropContainerWithPDFImages() {
      //lets find out the height of the image as per our container width.
      //check if the pdf image width is less than the dropContainerWidth, if yes then use the image width
      if (this.pdfPagesImages[0].width < this.dropContainerWidth) {
        this.dropContainerWidth = this.pdfPagesImages[0].width;
      }

      const pageImgAspectRatio = this.pdfPagesImages[0].width / this.pdfPagesImages[0].height;
      const singlePageheight = this.dropContainerWidth / pageImgAspectRatio;
      this.pdfPageHeight = singlePageheight;
      const totalPDFImages = this.totalCheckImages;
      this.dropContainerHeight = singlePageheight * totalPDFImages;
      //now lets add the page separator height, doing minus 1 boz we r not showing last border
      this.dropContainerHeight += (totalPDFImages - 1) * this.pdfPageSeparatorHeight;

      this.setPagesStartnEnd();
    },
    setPagesStartnEnd() {
      const self = this;
      self.pdfPagesStartEndArray = [];

      _.forEach(this.pdfPagesImages, function(imgObj, key) {
        const ao = key == 0 ? 0 : 1;
        const pdfPageHeight = key * self.pdfPageHeight;
        const pdfPageSeparatorHeight = self.pdfPageSeparatorHeight * key;
        const ps = pdfPageHeight + pdfPageSeparatorHeight + ao;
        const pe = ps + self.pdfPageHeight;
        self.pdfPagesStartEndArray.push({
          ps: ps,
          pe: pe
        });
      });
    },
    setPageNumberNyCoordinate(item, yCoordinate) {
      let pageNumber = _.findIndex(this.pdfPagesStartEndArray, function(p) {
        return yCoordinate >= p.ps && yCoordinate <= p.pe;
      });

      if (pageNumber == -1) {
        const pn = Math.floor(yCoordinate / this.pdfPageHeight);
        const y = this.pdfPagesStartEndArray[pn].ps - yCoordinate + yCoordinate;
        item.pageNumber = pn + 1;
        item.yCoordinate = y;
      } else {
        pageNumber++;

        item.pageNumber = pageNumber;

        //get the SingTab left and right
        const signBoxRight = item.xCoordinate + this.signTabWidth;
        const signBoxLeft = item.xCoordinate;
        const signBoxTop = yCoordinate;
        const signBoxBottom = yCoordinate + this.signTabHeight;

        //Now separator left and right
        const pageSepLeft = 0;
        const pageSepRight = this.dropContainerWidth;
        const updatedPdfPageHeight = pageNumber * this.pdfPageHeight;
        const updatedPdfPageSeparatorHeight = (pageNumber - 1) * this.pdfPageSeparatorHeight;
        const pageSepTop = updatedPdfPageHeight + updatedPdfPageSeparatorHeight + 1;
        const pageSepBottom = pageSepTop + this.pdfPageSeparatorHeight;

        const overlap = !(signBoxRight < pageSepLeft || signBoxLeft > pageSepRight || signBoxBottom < pageSepTop || signBoxTop > pageSepBottom);
        if (overlap) {
          item.yCoordinate = pageSepTop - this.signTabHeight - 1; //yCoordinate - (pageSepBottom - pageSepTop);
        } else {
          item.yCoordinate = yCoordinate;
        }
      }
    },
    redirectToDocumentListingPage() {
      switch (this.returnTo) {
        case "study-participant-documents":
          this.$router.push({
            name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}study-participant-documents`,
            params: {
              studyId: this.studyId
            }
          });
          break;
        case "add-research-site-documents":
          this.$router.push({
            name: `${this.isTestPortal ? TEST_PORTAL_SUFFIX : ""}add-research-site-documents`,
            params: {
              siteId: this.siteId
            }
          });
          break;
      }
    },
    scrollToId(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    },
    callSinglePdfImage() {
      const pathParams = {
        studyId: this.studyId,
        siteId: this.siteId,
        documentId: this.documentId
      };
      if (this.currentCount === 0) {
        this.$store.commit("SHOW_LOADER", true);
      }
      pathParams.page = this.currentCount;
      if (this.currentCount < this.totalMainPage) {
        this.pdfPagesLastIndexValue = this.pdfPagesImages.length;
        pathParams.page = parseInt(pathParams.page);
        this.$api.getSinglePagewiseConfiguredDocumentDetails(pathParams).then(
          response => {
            this.$store.commit("SHOW_LOADER", false);
            if (this.currentCount == 0) {
              this.documentData = response.body;
              this.originalDocumentName = this.documentData.docName;
              this.disclaimersObj = this.documentData.disclaimerList;
              this.signingTabs = this.documentData.platformDocumentConfigurations;
            }
            this.totalMainPage = parseInt(response.body.totalMainPage);
            this.pdfPagesImages = this.pdfPagesImages.concat(response.body.documentImages);
            this.currentCount = this.currentCount + 1;
            this.callSinglePdfImage(this.currentCount);
            this.setDropContainerWithPDFImages();
          },
          error => {
            this.$store.commit("SHOW_LOADER", false);
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting configured document details");
          }
        );
      } else {
        this.$store.commit("SHOW_LOADER", false);
        if (this.currentCount == this.totalMainPage) {
          this.setDropContainerWithPDFImages();
        }
      }
    },
    scrollImage(e) {
      if (e.target.offsetHeight + e.target.scrollTop + 5 >= e.target.scrollHeight) {
        if (this.currentCount != this.totalMainPage) {
          this.$store.commit("SHOW_LOADER", true);
        }
      }
    }
  },
  created() {
    //prepare role color code object, so that we can directly know which role has which color
    const self = this;
    _.forEach(this.dragabbleRoles, roleObj => {
      self.roleColorCode[roleObj.roleKey] = roleObj.color;
    });

    this.getConfiguredDocumentDetails();
  },
  destroyed() {
    this.currentCount = this.totalMainPage;
  }
};
</script>

<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style lang="scss" scoped>
.order-number {
  font-size: 10px;
  position: absolute;
  top: 0;
  right: 2px;
}
.config-container {
  background: #fff;
  .stage {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2rem 0;

    overflow: hidden;
    height: calc(100vh - 73px);
  }

  .container-top {
    border-bottom: 1px solid #d3dfe4;
    padding: 8px 16px 8px;
    position: fixed;
    right: 0;
    left: 200px;
    z-index: 99;
    background: #fff;

    .document-name {
      font-size: 16px;
      color: #000000;
      font-family: Roboto-Medium;
      margin-top: 4px;
      display: inline-block;

      .fa-pencil {
        color: #b0bac9;
        cursor: pointer;
      }
    }

    button.btn-primary {
      font-size: 14px;
      font-weight: bold;
      background-color: #1e8fe1;
      border-color: #1e8fe1;
      padding: 4px 39px;
      display: inline-block;
      &:hover {
        background-color: #007bff;
        color: #ffffff;
      }
    }

    .cancel-btn {
      color: #4a4a4a;
      font-size: 14px;
      vertical-align: middle;
      cursor: pointer;
      display: inline-block;
      margin-right: 21px;
      &:hover {
        color: #000000;
      }
      &.disabled {
        opacity: 0.65;
      }
    }

    .edit-document-name {
      .input-group-text {
        border-left: 0;
        background: #fff;
      }

      .fa-times {
        border: 0.5px solid;
        padding: 1.5px 3.5px;
        border-radius: 2px;
        cursor: pointer;
      }

      .fa-check-square {
        color: #1e8fe1;
        cursor: pointer;
      }

      input {
        &.docNameInput {
          border-right: 0;
        }
      }
    }
  }

  .left-outer-container {
    padding: 29px 40px;
    background: #f5f8fa;
    height: calc(100vh - 120px);
    min-height: calc(100vh - 120px);
    overflow-y: scroll;
    scroll-behavior: smooth;
    //Scrollbar CSS for Mozilla

    scrollbar-color: #9b9b9b #e5e5e5;
    /* thumb and track color */
    scrollbar-width: thin;

    //Below is the scrollbar css for Chrome
    &::-webkit-scrollbar {
      width: 8px;
      background-color: #e5e5e5;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #9b9b9b;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      background-color: #e5e5e5;
    }
    .document-container {
      border-top: 19px solid #e5e5e5;
      border-bottom: 19px solid #e5e5e5;
      border-left: 13px solid #e5e5e5;
      border-right: 13px solid #e5e5e5;

      .drop-zone {
        user-select: none;
        position: relative;
        display: flex;
        flex-direction: column;
        scroll-behavior: smooth;
        //Scrollbar CSS for Mozilla

        scrollbar-color: #9b9b9b #e5e5e5;
        /* thumb and track color */
        scrollbar-width: thin;

        //Below is the scrollbar css for Chrome
        &::-webkit-scrollbar {
          width: 6px;
          background-color: #e5e5e5;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #9b9b9b;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-track {
          //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          background-color: #e5e5e5;
        }

        .page-separator {
          background: #525659;

          &.last {
            display: none;
          }
        }

        img.page-img {
          user-select: none;
          -moz-user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -ms-user-select: none;
        }
      }

      .signing-tab {
        touch-action: none;
        border-radius: 3px;
        border: solid 1px #4c8ce4;
        position: absolute;
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;

        &.draggable {
          &.active-sign-tab {
            border: solid 2px #4c8ce4;
            box-shadow: 0 0 5px 0 #4c8ce4;
            padding: 7px;
          }
        }

        &.dragging {
          cursor: grabbing;
        }

        .color-indicator {
          width: 26px;
          height: 26px;
          border: 1px solid #c4c4c4;
          display: inline-table;
          border-radius: 25px;

          &.signature {
            background-image: url(/static/img/signature-icon.svg);
            background-position: center;
            background-repeat: no-repeat;
          }

          &.initials {
            background-image: url(/static/img/initials-icon.svg);
            background-position: center;
            background-repeat: no-repeat;
          }

          &.checkbox {
            background-image: url(/static/img/checkbox-icon.svg);
            background-position: center;
            background-repeat: no-repeat;
          }

          &.text {
            background-image: url(/static/img/text-icon.svg);
            background-position: center;
            background-repeat: no-repeat;
          }

          &.name {
            background-image: url(/static/img/name-icon.svg);
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }

  .right-outer-container {
    padding: 0;
    .right-panel {
      padding: 12px 0px;
      right: 0;
      overflow-y: auto;
      z-index: 98;
      min-height: calc(100vh - 120px);
      height: calc(100vh - 120px);
      scroll-behavior: smooth;
      //Scrollbar CSS for Mozilla

      scrollbar-color: #9b9b9b #e5e5e5;
      /* thumb and track color */
      scrollbar-width: thin;

      //Below is the scrollbar css for Chrome
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #e5e5e5;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #9b9b9b;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-track {
        background-color: #e5e5e5;
      }

      .roles-container {
        padding-left: 18px;
        padding-right: 15px;
        padding-bottom: 11px;

        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;

          li {
            border: 1px solid #d3dfe4;
            border-radius: 4px;
            padding: 6px 10px;
            margin-bottom: 3px;
            font-size: 12px;
            color: #000000;
            font-weight: 600;

            &[draggable="true"] {
              cursor: grab;
            }

            &:last-of-type {
              margin-bottom: 0;
            }

            &.no-select {
              -webkit-touch-callout: none; /* iOS Safari */
              -webkit-user-select: none; /* Safari */
              -khtml-user-select: none; /* Konqueror HTML */
              -moz-user-select: none; /* Old versions of Firefox */
              -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                            supported by Chrome, Edge, Opera and Firefox */
            }

            img {
              &.drag-bullet {
                margin-right: 4px;
                vertical-align: sub;
                user-select: none;
                -moz-user-select: none;
                -webkit-user-drag: none;
                -webkit-user-select: none;
                -ms-user-select: none;
              }
            }

            p {
              &.role-text {
                display: inline-block;
                vertical-align: middle;
                margin-top: 0px;
                margin-bottom: 0px;
                width: 70%;
              }
            }

            .color-indicator {
              width: 17px;
              height: 17px;
              border: 1px solid #c4c4c4;
              display: inline-block;
              border-radius: 25px;
              float: right;
              margin-right: 4px;
              margin-top: 1px;
            }

            .extra-margin {
              margin: 9px 4px;
            }

            .drag-role {
              border-radius: 3px;
              border: solid 1px #4c8ce4;
              display: inline-flex;
              padding: 8px;
              background: #ffffff;

              .role-color-indicator {
                width: 26px;
                height: 26px;
                border: 1px solid #c4c4c4;
                display: inline-block;
                border-radius: 25px;
              }
            }
          }
        }
      }

      .disclaimer-container {
        border: solid 1px #d3dee3;
        background-color: rgba(228, 232, 235, 0.2);

        ul {
          margin: 0;
          padding: 10px 14px 9px 9px;

          li {
            list-style: none;
            font-size: 12px;
            color: #1e8fe1;
            margin-bottom: 4px;

            &:last-of-type {
              margin-bottom: 0;
            }

            .fa-pencil {
              float: right;
              color: #b0bac9;
              cursor: pointer;
              font-size: 15px;
            }
          }
        }
      }

      .disclaimer-btn-container {
        margin-top: 8px;

        button.btn {
          color: #0089ea;
          border-color: #1e8fe1;
          font-size: 12px;
          padding: 5px 14px;

          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .col-md-9.left-outer-container {
    -ms-flex: 0 0 79%;
    flex: 0 0 79%;
    max-width: 79%;
  }

  .col-md-3.right-outer-container {
    -ms-flex: 0 0 21%;
    flex: 0 0 21%;
    max-width: 21%;
  }
}
@media (min-width: 768px) and (max-width: 1111px) {
  .config-container .container-top[data-v-6a271137] {
    left: 0px;
  }
  .config-container .left-outer-container {
    padding: 35px 15px;
  }
  .config-container .right-outer-container .right-panel {
    padding: 35px 0px;
  }
}
@-moz-document url-prefix() {
  .disclaimer-btn-container {
    padding-bottom: 15px;
  }
  .left-outer-container {
    padding-bottom: 29px;
  }
}
.disabledScreen {
  pointer-events: none;
  opacity: 0.4;
}
</style>
